/* RESPONSIBLE TEAM: team-inbox */
import IntercomRoute from 'embercom/routes/base/intercom-route';
import { inject as service } from '@ember/service';
import type CustomReportsService from 'embercom/services/custom-reports-service';

export default class CopilotRoute extends IntercomRoute {
  @service declare customReportsService: CustomReportsService;

  beforeModel() {
    this.customReportsService.routeToOverviewPage();
  }
}
